// extracted by mini-css-extract-plugin
var _1 = "LoadingIndicator-module__adaptColor--abQ3d";
var _2 = "LoadingIndicator-module__dot--aKFxx";
var _3 = "LoadingIndicator-module__last--gInZq";
var _4 = "LoadingIndicator-module__middle--zX1QB";
var _5 = "LoadingIndicator-module__typing--nyMaU";
var _6 = "LoadingIndicator-module__wrapper--coovG";
export { _1 as "adaptColor", _2 as "dot", _3 as "last", _4 as "middle", _5 as "typing", _6 as "wrapper" }
